<script setup lang="ts">
import { computed, ref } from 'vue';
import { OverlayView } from '@hfc/ui-core';
import SmallBusinessStickyBox from '@/application/smallBusiness/infrastructure/components/SmallBusinessStickyBox.vue';
import { SmallBusinessPlan } from '@/application/smallBusiness/domain/SmallBusinessPlan';
import { useSmallBusinessStore } from '@/application/smallBusiness/infrastructure/composition/useSmallBusinessStore';

defineProps<{
  disableRemovePlans?: boolean;
  hideClearAndRestart?: boolean;
}>();

const { smallBusinessStore, smallBusinessState } = useSmallBusinessStore();

const plans = computed(() => smallBusinessState.value.application.plans as Array<SmallBusinessPlan>);

const overlayOpen = ref(false);

const removeSelectedPlan = (plan: SmallBusinessPlan): void => {
  smallBusinessStore.removeSelectedPlan(plan);
};
</script>
<template>
  <div class="hidden xl:flex flex-col w-48">
    <SmallBusinessStickyBox :plans="plans" :disable-remove-plans="disableRemovePlans" @remove-plan="removeSelectedPlan" />
  </div>
  <OverlayView class="flex xl:hidden" title="Selected Plans" v-model:is-open="overlayOpen" :self-trigger="true" @close="overlayOpen = false">
    <template #trigger>
      <hfc-icon icon="cart-shopping" class="text-blue-500 text-xl" />
      <div class="absolute flex  justify-center top-0 right-0 bg-red rounded-full text-white w-4 h-4 text-[10px] leading-[14px]">{{plans.length}}</div>
    </template>
    <div class="flex flex-col items-center">
      <SmallBusinessStickyBox :plans="plans" :disable-remove-plans="disableRemovePlans" @remove-plan="removeSelectedPlan" />
    </div>
  </OverlayView>
</template>
